/** Where a dashboard's `products` become a sidebar group and a portal `product=` filter. */

import { DashboardSummaryProductsEnum } from '../gen/openapi';

/** Re-exported so the dashboard reads the vocabulary from here, not from a generated model. */
export const DashboardProduct = DashboardSummaryProductsEnum;
export type DashboardProduct = DashboardSummaryProductsEnum;

/** One entry per sidebar group. A product belongs to exactly one. */
export const PRODUCT_GROUPS: { label: string; products: DashboardProduct[] }[] = [
  { label: 'ARTESCA', products: [DashboardProduct.Artesca] },
  { label: 'RING / ADI', products: [DashboardProduct.Ring, DashboardProduct.Adi] },
];

/** Where a dashboard declaring no product goes, so nothing silently vanishes from the list. */
export const UNGROUPED_LABEL = 'Other';

/** The portal knows `ARTESCA | RING` only, so ADI has to be asked for as RING. */
const PORTAL_PRODUCT_BY_DASHBOARD_PRODUCT: Partial<Record<DashboardProduct, string>> = {
  [DashboardProduct.Adi]: DashboardProduct.Ring,
};

/** The `product=` values for a dashboard's products, deduplicated. */
export const portalProductsFor = (products: DashboardProduct[] = []): string[] => [
  ...new Set(products.map((product) => PORTAL_PRODUCT_BY_DASHBOARD_PRODUCT[product] ?? product)),
];

/** `UNGROUPED_LABEL` when the dashboard declares no product we group on. */
export const productGroupLabelFor = (products: DashboardProduct[] = []): string =>
  PRODUCT_GROUPS.find((group) => products.some((product) => group.products.includes(product)))?.label ??
  UNGROUPED_LABEL;
